// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-above-row-left';

export const Component = () => (
  <path d='M11.016 2.719 10.346 2l-5.7 5.029 5.7 4.98.67-.718-4.31-3.784h17.816v-.958H6.658l4.358-3.831ZM24.52 21.924H0v-8.812h24.521v8.812Zm-7.855-7.854v6.896h6.897V14.07h-6.897Zm-7.854 0v6.896h6.897V14.07H8.813Zm-7.854 0v6.896h6.897V14.07H.958Z' />
);

export const viewBox = '0 0 25 25';
